<template>
  <!-- 头部导航 -->
  <div>
    <div class="headerNav pc">
      <div
        class="content"
        style="
          z-index: 998;
          box-shadow: 0px 2px 10px 1px rgba(63, 107, 51, 0.44);
        "
      >
        <div @click="goHome" style="cursor: pointer">
          <img src="@/assets/logo.png" style="height: 80px" alt="" />
        </div>
        <div
          @click="goHome"
          style="cursor: pointer; margin-left: 25px; margin-right: 40px"
        >
          <div
            style="
              font-size: 32px;
              font-weight: bold;
              color: #000000;
              line-height: 32px;
              margin-bottom: 9px;
            "
          >
            御方汇
          </div>
          <div
            style="
              font-size: 20px;
              font-weight: normal;
              color: #000000;
              line-height: 22px;
            "
          >
            黄家圣幸实业集团旗下原料品牌
          </div>
        </div>
        <div class="align-right" style="min-width: 745px; overflow: hidden">
          <div
            style="
              font-size: 15px;
              color: #3f6b33;
              float: right;
              background: #d9e1d6;
              padding: 2px 19px 2px 15px;
              border-radius: 4px;
              letter-spacing: 0px;
            "
          >
            <img src="@/assets/message.png" alt="" style="width: 21px" />
            <span style="margin-left: 9px; min-width: 800px">{{
              email || "yufanghui@163.com"
            }}</span>
            <img
              src="@/assets/phone.png"
              alt=""
              style="width: 20px; margin-left: 35px"
            />
            <span style="margin-left: 6px; min-width: 300px">{{
              phone || "4001-004-406"
            }}</span>
          </div>
          <div style="margin-top: 30px">
            <div>
              <el-menu
                :default-active="activeIndex"
                class="el-menu-demo"
                mode="horizontal"
              >
                <el-menu-item
                  v-for="(item, index) of menuList"
                  :key="index"
                  :index="item.component"
                  @click="goUrl(item.component)"
                  class="RightToCenter"
                  :style="`animation-duration: ${0.1 * (index + 1) + 0.2}s;`"
                  >{{ item.menuName || "" }}</el-menu-item
                >
                <el-menu-item
                  class="RightToCenter"
                  :style="`animation-duration: ${
                    0.1 * (menuList.length + 1) + 0.2
                  }s;`"
                >
                  <el-input
                    v-model="searchText"
                    ref="searchValue1"
                    :class="searchShow?'showSearch':'hideSearch'"
                    style="transition: all 0.5s ease 0s;"
                    :style="`width: ${!searchShow ? 40:260}px;`"
                    @blur="searchBlurFun"
                    placeholder="请检索新闻内容"
                    @keyup.enter.native="searchBtn"
                  >
                    <i slot="suffix" class="el-input__icon el-icon-search" @click="searchBtn(1)"></i>
                  </el-input>
                </el-menu-item>
              </el-menu>
            </div>
          </div>
        </div>
      </div>
      <div
        class="content"
        v-if="show"
        style="
          padding: 12px 0;
          position: fixed;
          top: 0;
          width: 100%;
          background: #fff;
          box-shadow: 0px 2px 10px 1px rgba(63, 107, 51, 0.44);
          z-index: 999;
        "
      >
        <div @click="goHome" style="cursor: pointer">
          <img src="@/assets/logo.png" style="height: 60px" alt="" />
        </div>
        <div
          @click="goHome"
          style="cursor: pointer; margin-left: 25px; margin-right: 160px"
        >
          <div
            style="
              font-size: 30px;
              font-weight: bold;
              color: #000000;
              line-height: 36px;
              margin-bottom: 9px;
            "
          >
            御方汇
          </div>
          <div
            style="
              font-size: 18px;
              font-weight: normal;
              color: #000000;
              line-height: 20px;
            "
          >
            黄家圣幸实业集团旗下原料品牌
          </div>
        </div>
        <div class="align-right">
          <div>
            <el-menu
              :default-active="activeIndex"
              class="el-menu-demo"
              mode="horizontal"
            >
              <el-menu-item
                v-for="(item, index) of menuList"
                :key="index"
                :index="item.component"
                @click="goUrl(item.component)"
                >{{ item.menuName || "" }}</el-menu-item
              >
              <el-menu-item>
                  <el-input
                    v-model="searchText"
                    ref="searchValue2"
                    :class="searchShow?'showSearch':'hideSearch'"
                    style="transition: all 0.5s ease 0s;"
                    :style="`width: ${!searchShow ? 40:260}px;`"
                    @blur="searchBlurFun"
                    placeholder="请检索新闻内容"
                    @keyup.enter.native="searchBtn"
                  >
                    <i slot="suffix" class="el-input__icon el-icon-search" @click="searchBtn(2)"></i>
                  </el-input>
                </el-menu-item>
            </el-menu>
          </div>
        </div>
      </div>
    </div>
    <div class="headerNav mobile">
      <div
        class="display-flex"
        style="
          align-items: center;
          background: #3f6b33;
          padding: 0.06rem 0.2rem;
          position: fixed;
          z-index: 22000;
          top: 0;
          width: calc(100% - 0.4rem);
        "
      >
        <div @click="goHome" style="cursor: pointer">
          <img src="@/assets/logo1.png" style="width: 0.38rem" alt="" />
        </div>
        <div
          @click="goHome"
          style="cursor: pointer; margin-left: 0.13rem; flex: 1"
        >
          <div
            style="
              font-size: 0.22rem;
              font-weight: bold;
              color: #fff;
              line-height: 0.26rem;
              margin-bottom: 0.05rem;
            "
          >
            御方汇
          </div>
          <div
            style="
              font-size: 0.14rem;
              font-weight: normal;
              color: #fff;
              line-height: 0.14rem;
            "
          >
            黄家圣幸实业集团旗下原料品牌
          </div>
        </div>
        <div style="width: 0.28rem" @click="showPop = !showPop">
          <img
            src="@/assets/menu.png"
            alt=""
            style="width: 100%"
            v-if="!showPop"
          />
          <img
            src="@/assets/close.png"
            alt=""
            style="width: 100%"
            v-if="showPop"
          />
        </div>
      </div>
      <van-popup
        v-model="showPop"
        position="right"
        :style="{ height: '100%' }"
        style="margin-top: 0.58rem"
        get-container=".swipe-bg"
      >
        <!-- <el-input v-model="searchValue" style="border-radius:50px;">
          
        </el-input> -->
        <div
          style="
            border: 1px solid #e5e5e5;
            border-radius: 50px;
            padding: 0.1rem 0.2rem;
            margin: 0.2rem 0.1rem 0;
            font-size: 0.16rem;
            display: flex;
            align-items: center;
            color: #ccc;
          "
          @click="goSearch"
        >
          <div style="flex: 1">新闻搜索</div>
          <div><i class="el-icon-search"></i></div>
        </div>
        <div
          style="
            width: calc(100vw - 0.8rem);
            text-align: left;
            min-height: 0.5rem;
            padding: 0 0.4rem;
            line-height: 0.6rem;
            border-bottom: 1px solid #e5e5e5;
            font-size: 0.16rem;
            position: relative;
          "
          :style="
            `${showPop ? 'opacity: 1;' : 'opacity: 0;'}animation-duration: ${
              0.3 + 0.1 * index
            }s;` +
            (menuName === item.component
              ? `
            color:#181818
            ;`
              : `color:#181818`)
          "
          v-for="(item, index) of menuList"
          :key="index"
          @click="goAppPage(item, item.component)"
          class="RightToCenter"
        >
          {{ item.menuName }}
          <div
            style="position: absolute; right: 10px; top: 0"
            v-if="item.children.length !== 0"
          >
            <i
              class="el-icon-minus"
              style="font-size: 0.2rem"
              v-if="menuName === item.component"
            ></i>
            <i class="el-icon-plus" style="font-size: 0.2rem" v-else></i>
          </div>
          <!-- && menuName === item.name -->
          <template>
            <div
              class="menuChildren"
              :class="`class${item.component}`"
              style="font-size: 0.16rem; color: #666"
              v-show="item.children.length !== 0 && menuName === item.component"
            >
              <div
                @click="goAppPage(items, item.component)"
                v-for="(items, indexs) of item.children"
                :key="indexs"
              >
                {{ items.menuName || items.main_title }}
              </div>
            </div>
          </template>
        </div>
      </van-popup>
      <BottomBar :active="activeIndex" style="z-index: 999999"></BottomBar>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import BottomBar from "@/components/bottomBar/index";
import { menuList } from "@/api/common";
export default {
  name: "headerNav",
  components: { BottomBar },
  props: {
    activeIndex: {
      type: String,
      default: "home",
    },
  },
  data() {
    return {
      menuList: [],
      show: false,
      mobile: false,
      phone: "",
      email: "",
      loading: true,
      showPop: false,
      menuName: "/",
      url: "",
      joinObj: "",
      searchText: "",
      searchShow: false,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.getScroll);
    // 公司电话
    this.getDate();
    this.getmenulist();
  },
  methods: {
    getmenulist() {
      //获取pc端菜单
      if (this.saveMenuList() === null) {
        menuList({ typeOf: 1 }).then((res) => {
          this.menuList = res.data;
          this.menuList.forEach((item) => {
            if (item.component === this.activeIndex) {
              this.$emit(
                "setBanner",
                this.getUrlPrefix(item.images),
                this.getUrlPrefix(item.mobileImages)
              );
              this.$emit("getChildren", item.children);
            }
            if (item.component === "customer" && item.children.length !== 0) {
              item.children.forEach((items) => {
                if (items.component === "joinUs") {
                  this.joinObj = items;
                  // console.log(`joinObj:`, this.joinObj);
                  this.$emit("getJoinObj", this.joinObj);
                }
              });
            }
          });
          this.saveMenuList(this.menuList);
          this.loading = false;
        });
      } else {
        this.menuList = this.saveMenuList();
        this.menuList.forEach((item) => {
          if (item.component === this.activeIndex) {
            this.$emit(
              "setBanner",
              this.getUrlPrefix(item.images),
              this.getUrlPrefix(item.mobileImages)
            );
            this.$emit("getChildren", item.children);
          }
          if (item.component === "customer" && item.children.length !== 0) {
            item.children.forEach((items) => {
              if (items.component === "joinUs") {
                this.joinObj = items;
                // console.log(`joinObj:`, this.joinObj);
                this.$emit("getJoinObj", this.joinObj);
              }
            });
          }
        });
        this.loading = false;
      }
    },
    getDate() {
      this.email = this.getBaseInfo().email;
      this.phone = this.getBaseInfo().phone;
    },
    goUrl(name) {
      this.$router.push({ name });
    },
    goHome() {
      this.$router.push({ name: "home" });
    },
    getScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (this.mobile === false) {
        this.show = scrollTop > 100;
      }
      this.searchShow = false
        this.$refs["searchValue1"].blur();
        if(this.show === true){
          this.$refs["searchValue2"].blur();
        }
    },
    goAppPage(item, name) {
      if (item.children.length !== 0) {
        if (this.menuName !== item.component) {
          this.menuName = item.component;
          $(`.class${name}`).slideDown("fast");
        } else if (this.menuName === item.component) {
          $(`.class${name}`).slideUp("fast");
          var that = this;
          setTimeout(() => {
            that.menuName = "";
          }, 200);
        }
      } else if (item.url.indexOf("#") !== -1) {
        var path = `/${item.component}${item.url}`;
        this.url = `${item.url}`;
        this.$router.push({ path });
        this.showPop = false;
        this.menuName = item.component;
        this.$emit("getContent", item.content);
      } else {
        this.url = "";
        this.$router.push({ name: item.component });
        this.$emit("getContent", item.content);
        if (item.component === "joinUs") {
          console.log(item.component, this.joinObj);
        }
      }
    },
    goSearch() {
      this.$router.push({ name: "search" });
      this.showPop = false;
    },
    searchBtn(type) {
      if(this.searchShow === false){
        this.searchShow = !this.searchShow;
        // this.$refs.searchBar.focus()
        this.$refs["searchValue"+type].focus();
      }else if(this.$route.name!=="search"){
        this.$router.push({name:"search",query:{key:this.searchText}})
      }else{
        this.$emit("getValue", this.searchText);
      }
    },
    searchBlurFun(){
      var that = this
      setTimeout(() => {
        that.searchShow = false
        that.$refs["searchValue1"].blur();
        that.$refs["searchValue2"].blur();
      }, 300);
    }
  },
  watch: {
    url: function (val) {
      if (val !== "") {
        this.$emit("getUrl", val);
      }
    },
  },
};
</script>

<style lang="scss">
.headerNav {
  /* position:fixed;
    top:0;
    left: 0; */
  width: 100%;
  z-index: 100;
  .content {
    display: flex;
    align-items: center;
    padding: 12px 0 6px;
    justify-content: center;
  }
  .el-menu {
    height: 60px;
    line-height: 60px;
  }
  .el-menu-item {
    padding: 0;
  }
  .el-menu.el-menu--horizontal {
    border-bottom: 0;
  }
  .el-menu--horizontal > .el-menu-item.is-active {
    position: relative;
    border-bottom: 0;
  }
  .el-menu--horizontal > .el-menu-item::after {
    content: "";
    width: 0;
    height: 2px;
    background: #3f6b33;
    position: absolute;
    bottom: 0px;
    left: 0;
    transition: all 0.5s ease 0s;
  }
  .el-menu--horizontal > .el-menu-item.is-active::after {
    width: 100%;
  }
  .el-submenu__title i {
    display: none;
  }
  .el-menu--horizontal > .el-menu-item {
    min-width: 96px;
    margin-left: 25px;
    font-size: 20px;
    color: #1b1b1b !important;
    height: 50px;
    line-height: 50px;
    text-align: center;
    font-weight: 500;
    border-bottom: 0;
  }
  .el-menu--horizontal > .el-menu-item:not(:last-child):hover::after {
    content: "";
    width: 100%;
    height: 2px;
    background: #3f6b33;
    position: absolute;
    bottom: 0px;
    left: 0;
    transition: all 0.5s ease 0s;
  }
  .el-menu--horizontal > .el-menu-item:last-child {
    min-width: 16px;
    line-height: 40px;
    margin-top: 5px;
    .showSearch{
      .el-input__inner:focus {
        border-color: #3f6b33 !important;
      }
    }
    .hideSearch{
      .el-input__inner{
        border: 0;
      }
    }
    i {
      font-size: 20px;
      color: #1b1b1b;
      font-weight: bold;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/headerNav/index.vue